import { KALEIDOSCOPE } from '../../theme/kaleidoscope';
import type { ActivityId } from '../../components/projects/workspace/projectActivities';

export type ExperiencePhase = ActivityId;

export interface PhaseExperience {
  id: ExperiencePhase;
  label: string;
  verb: string;
  tagline: string;
  color: string;
  atmosphere: string;
  glow: string;
  mesh: string;
}

export const PHASE_EXPERIENCE: Record<ExperiencePhase, PhaseExperience> = {
  discover: {
    id: 'discover',
    label: 'Discover',
    verb: 'Discovering',
    tagline: 'Repository ingestion, indexing, and baseline',
    color: KALEIDOSCOPE.discover,
    atmosphere:
      'radial-gradient(ellipse 80% 50% at 10% -20%, rgba(45, 212, 191, 0.14) 0%, transparent 55%), radial-gradient(ellipse 50% 40% at 90% 0%, rgba(45, 212, 191, 0.07) 0%, transparent 50%)',
    glow: 'rgba(45, 212, 191, 0.32)',
    mesh: 'rgba(45, 212, 191, 0.08)',
  },
  understand: {
    id: 'understand',
    label: 'Understand',
    verb: 'Understanding',
    tagline: 'Architecture, dependencies, and system knowledge',
    color: KALEIDOSCOPE.understand,
    atmosphere:
      'radial-gradient(ellipse 75% 55% at 15% -15%, rgba(155, 158, 255, 0.14) 0%, transparent 58%), radial-gradient(ellipse 45% 35% at 85% 5%, rgba(56, 189, 248, 0.08) 0%, transparent 48%)',
    glow: 'rgba(155, 158, 255, 0.36)',
    mesh: 'rgba(155, 158, 255, 0.09)',
  },
  operate: {
    id: 'operate',
    label: 'Operate',
    verb: 'Operating',
    tagline: 'Incidents, requests, and engineering work in production',
    color: KALEIDOSCOPE.operate,
    atmosphere:
      'radial-gradient(ellipse 72% 48% at 8% -12%, rgba(251, 146, 60, 0.13) 0%, transparent 52%), radial-gradient(ellipse 50% 38% at 92% 4%, rgba(251, 146, 60, 0.06) 0%, transparent 46%)',
    glow: 'rgba(251, 146, 60, 0.34)',
    mesh: 'rgba(251, 146, 60, 0.08)',
  },
};

/**
 * Lifecycle phase for a workspace path. Project-wide surfaces outside the
 * Discover → Understand → Operate loop (governance, enterprise, releases,
 * portfolio, knowledge library, insights) return undefined so no phase is
 * highlighted and no phase section tabs are shown for them.
 */
export function phaseForPath(pathname: string): ExperiencePhase | undefined {
  if (pathname.includes('/phase-0') || pathname.includes('/ingestion')) return 'discover';
  if (pathname.includes('/phase-1')) return 'understand';
  if (
    pathname.includes('/operate') ||
    pathname.includes('/ams') ||
    pathname.includes('/phase-2') ||
    pathname.includes('/phase-3') ||
    pathname.includes('/modernization')
  ) {
    return 'operate';
  }
  return undefined;
}
